import React, { Component } from 'react';
import PropTypes from 'prop-types';
import data from 'emoji-mart/data/emojione';
import { NimblePicker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';

export default class EmojiDropdownContent extends Component {
    showNativeEmoji() {
        const platform = navigator.platform.toLocaleLowerCase();

        if (!platform) {
            return false;
        }

        return (
            platform.indexOf('mac') > -1 ||
            platform.indexOf('iphone') > -1 ||
            platform.indexOf('ipad') > -1 ||
            platform.indexOf('android') > -1 ||
            platform.indexOf('ipod') > -1
        );
    }

    render() {
        return (
            <div>
                <NimblePicker
                    set="emojione"
                    data={data}
                    color="#fd7c66"
                    native={this.showNativeEmoji()}
                    title=""
                    emojiSize={20}
                    sheetSize={20}
                    onClick={this.props.onEmojiSelect}
                    perLine={8}
                />
            </div>
        );
    }
}

EmojiDropdownContent.propTypes = {
    onEmojiSelect: PropTypes.func
};
